import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';

export const client = new ApolloClient({
  uri: process.env.GATSBY_APP_SYNC_URL,
  fetch,
  request: operation => {
    const context = {
      headers: {
        'x-api-key': process.env.GATSBY_APP_SYNC_KEY,
      },
    };

    operation.setContext(context);
  },
  onError: ({ networkError, graphQLErrors }) => {
    if (graphQLErrors) {
      const error = graphQLErrors[0];
      console.warn('GraphQL error: ', error);
    }

    if (networkError) {
      console.warn('networkError', networkError);
    }
  },
});
